<template>
	<el-container>
		<el-header v-if="usertype==1" >
			<el-menu mode="horizontal">
				<el-menu-item @click='breakusers' index="1">智能空压机程序</el-menu-item>
				<el-menu-item index="2">智能清洗机程序</el-menu-item>
			</el-menu>
		</el-header>
		<el-main class="long_range">
			<el-table v-show="now_openid==''" :span="24" :data="connectedList" highlight-current-row v-loading="listLoading"  style="width: 100%;">
				<el-table-column type="index" >
				</el-table-column>
				<el-table-column  prop="name" label="用户昵称"  sortable>
				</el-table-column>
				<el-table-column  prop="upper_sysno" label="自定义数据" sortable>
					<template slot-scope="scope">
            <!-- :readonly="true" -->
						<el-input v-model="sendUserMessage" placeholder="自定义内容"  ></el-input>
				    </template>
				</el-table-column>
				<el-table-column prop="upper_sysno" label="发送数据"  sortable>
					<template slot-scope="scope">
            <!-- :disabled='GLOBAL.organ_sysno==GLOBAL.adminSysno.adminOrgan' -->
				         <el-button  size="mini" @click="handleEdit(scope.$index, scope.row)">点击发送自定义数据</el-button>
				    </template>
				</el-table-column>
				<el-table-column prop="account" label="操作"  sortable>
					<template slot-scope="scope">
				        <el-button size="mini" @click="joinUser(scope.$index, scope.row)">点击接入用户</el-button>
				    </template>
				</el-table-column>
			</el-table>
			<div class="join_user count_right_sendmessage" v-if="now_openid!=''">
				<div class="menuJoin">
					<el-button @click="breakusers">返回</el-button>
					<el-menu :default-active="menu_join" mode="horizontal">
						<el-menu-item @click="changenow_model('join_user_one')" index="1">当前信息</el-menu-item>
						<el-menu-item :disabled='!!time_read' @click="changenow_model('join_user_two')" index="2">配置信息</el-menu-item>
					</el-menu>
				</div>
				<div v-show="now_model=='join_user_one'" id="join_user_one" class="count_right_sendmessage_down">
					<el-row class="line-message" >
					</el-row>
					<el-row class="line-message">
						<el-col :span="6">
							<span>空载中压</span>
							<el-input :readonly="true" :value="setmessage.data.no_load_center" type="text"></el-input>
							<i></i>
						</el-col>
						<el-col :span="6">
							<span>满载中压</span>
							<el-input :readonly="true" :value="setmessage.data.full_load_center" type="text"></el-input>
							<i></i>
						</el-col>
						<!---->
						<el-col  class='now_state' :span="6">
							<div :class="read_current_fn.data.full_no==1&&read_current_fn.data.water_light_one==0&&read_current_fn.data.electric_machinery==1?'start':'close'">
								<span>水枪</span>
								<i></i>
							</div>
							<div :class="read_current_fn.data.full_no=='1'?'start':'close'">
								<span>电机</span>
								<i></i>
							</div>
							<div :class="!read_current_fn.data.electric_machinery?'close':'start'">
								<span>主机</span>
								<i></i>
							</div>
						</el-col>
						<el-col :span="6" class="now_state">
							<!--<div style="flex: none;width: 26px;" :class="!!read_current_fn.data.machinery_state?'start':'close'">
								<i></i>
							</div>-->
							<el-button :disabled='!!time_read' @click='startTimer'>读取电流</el-button>
							<el-button :disabled='!time_read' @click='stopTimer'>停读电流</el-button>
						</el-col>
					</el-row>
					<el-row class="line-message">
						<el-col :span="6" >
							<span>实时电压</span>
							<el-input :readonly="true"  :value="read_current_fn.data.voltage_now" type="text"></el-input>
							<i>V</i>
						</el-col>
						<el-col :span="6" >
							<span>实时电流</span>
							<el-input :readonly="true"  :value="read_current_fn.data.electric_now" type="text"></el-input>
							<i>A</i>
						</el-col>
						<el-col :span="6">
							<span>实时漏电</span>
							<el-input :readonly="true"  :value="read_current_fn.data.electric_leakage_now" type="text"></el-input>
							<i>mA</i>
						</el-col>
						<el-col :span="6" >
							<span>漏电参考</span>
							<el-input :readonly="true"  :value="setmessage.data.reference_electric_leakage" type="text"></el-input>
							<i></i>
						</el-col>
					</el-row>
					<el-row class="line-message">
						<el-col :span="6" >
							<span>用电总量</span>
							<el-input :readonly="true"  :value="read_current_fn.data.electricity_use_now" type="text"></el-input>
							<i></i>
						</el-col>
						<el-col :span="6" >
							<span>每秒焦耳</span>
							<el-input :readonly="true"  :value="read_current_fn.data.electricity_use_second" type="text"></el-input>
							<i></i>
						</el-col>
						<el-col :span="6">
							<span>实时水流</span>
							<el-input :readonly="true"  :value="read_current_fn.data.electric_leakage_now" type="text"></el-input>
							<i></i>
						</el-col>
						<el-col :span="6" >
							<span>实时流速</span>
							<el-input :readonly="true"  :value="read_current_fn.data.water_use_second" type="text"></el-input>
							<i></i>
						</el-col>
					</el-row>
					<el-row class='line-message'>
						<el-col  :span="6">
							<span>设备型号</span>
							<el-input :readonly="true" :value="setmessage.data.phase" type="text"></el-input>
							<i></i>
						</el-col>
						<el-col :span="6">
							<span>版本号</span>
							<el-input :readonly="true" :value="setmessage.data.edition" type="text"></el-input>
							<i></i>
						</el-col>
						<el-col :span="6">
							<span>滚码号</span>
							<el-input :readonly="true"  :value="setmessage.data.roll_code" type="text"></el-input>
							<i></i>
						</el-col>
						<el-col :span="6">
							<span>R_Tan</span>
							<el-input :readonly="true"   :value="read_current_fn.data.tan" type="text"></el-input>
							<i>A</i>
						</el-col>
						<!--<el-col :span="6">
							<span>运行时长</span>
							<el-input :readonly="true"  :value="setmessage.data.roll_code" type="text"></el-input>
							<i></i>
						</el-col>-->
					</el-row>
					<el-row class='line-message'>
						<el-col  :span="6">
							<span>漏电次数</span>
							<el-input :readonly="true" :value="setmessage.data.electric_leakage_second" type="text"></el-input>
							<i></i>
						</el-col>
						<el-col :span="6">
							<span>过载次数</span>
							<el-input :readonly="true" :value="setmessage.data.overload_times" type="text"></el-input>
							<i></i>
						</el-col>
						<el-col :span="6">
							<span>换油次数</span>
							<el-input :readonly="true"  :value="setmessage.data.oil_change" type="text"></el-input>
							<i></i>
						</el-col>
						<el-col :span="6">
							<span>过载最大电流</span>
							<el-input :readonly="true"   :value="setmessage.data.overload_max" type="text"></el-input>
							<i>A</i>
						</el-col>
						<!--<el-col :span="6">
							<span>运行时长</span>
							<el-input :readonly="true"  :value="setmessage.data.roll_code" type="text"></el-input>
							<i></i>
						</el-col>-->
					</el-row>
					<el-row class="line-message" v-if='setmessage.data.phase!="S810"'>
						<el-col :span="6">
							<span>R_Tan</span>
							<el-input :readonly="true"   :value="read_current_fn.data.tan" type="text"></el-input>
							<i>A</i>
						</el-col>
						<el-col  :span="6" class='wid-6'>
							<span>L1</span>
							<el-input :readonly="true"  :value="read_current_fn.data.electric_now_two" type="text"></el-input>
							<i>A</i>
						</el-col>
						<el-col :span="6" class='wid-6' >
							<span>L2</span>
							<el-input :readonly="true"  :value="read_current_fn.data.electric_now_three" type="text"></el-input>
							<i>A</i>
						</el-col>
						<el-col :span="6"  class='wid-6'>
							<span>L3</span>
							<el-input :readonly="true"  :value="read_current_fn.data.l1_electric" type="text"></el-input>
							<i>A</i>
						</el-col>
					</el-row>
				</div>
				<div v-show="now_model=='join_user_two'" id="join_user_two" class="count_right_sendmessage_down">
					<el-row class="line-message">
						<el-col :span='6'>
							<span>外接开关类型</span>
							<el-select v-model="setmessage.data.switch_state"  @change='changemessage'>
							    <el-option label="常闭开关" value="00"></el-option>
							    <el-option label="常开开关"	value="01"></el-option>
							    <el-option label="无线开关"	value="02"></el-option>
							    <el-option label="水流开关"	value="03"></el-option>
							    <el-option label="压力开关"	value="04"></el-option>
							    <el-option label="手动开关"	value="012f"></el-option>
						  	</el-select>
					  		<el-button class="btn" @click="send_setmessage('0E','switch_state')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>额定电流</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.electric_less"></el-input>
					  		<el-button class="btn" @click="send_setmessage('01','electric_less')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>关枪延时</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.gun_offdelayed"></el-input>
					  		<el-button class="btn" @click="send_setmessage('0B','gun_offdelayed')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>开枪延时</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.gun_ontime"></el-input>
					  		<el-button class="btn" @click="send_setmessage('28','gun_ontime')">点击发送</el-button>
						</el-col>
					</el-row>

					<el-row class="line-message">
						<el-col :span='6'>
							<span>自动关机时间</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.automatic_shutdown"></el-input>
					  		<el-button class="btn" @click="send_setmessage('0C','automatic_shutdown')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>最长运转时间</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.max_worktime"></el-input>
					  		<el-button class="btn" @click="send_setmessage('26','max_worktime')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>工作频率</span>
							<el-select v-model="setmessage.data.rate"  @change='changemessage'>
							    <el-option label="50Hz" value="00"></el-option>
							    <el-option label="60Hz"	value="01"></el-option>
						  	</el-select>
					  		<el-button class="btn" @click="send_setmessage('25','rate')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>枪数选择</span>
							<el-select v-model="setmessage.data.gun_num"  @change='changemessage'>
							    <el-option label="一机一枪" value="00"></el-option>
							    <el-option label="一机双枪"	value="01"></el-option>
							    <el-option label="一机三枪"	value="02"></el-option>
						  	</el-select>
					  		<el-button class="btn" @click="send_setmessage('48','gun_num')">点击发送</el-button>
						</el-col>
					</el-row>
					<el-row class="line-message">
						<el-col :span='6'>
							<span>漏电保护</span>
							<el-switch @change='changemessage' active-value='00' inactive-value='01' v-model="setmessage.data.switch_leakage" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
					  		<el-button class="btn" @click="send_setmessage('0D','switch_leakage')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>过载保护</span>
							<el-switch @change='changemessage' active-value='00' inactive-value='01' v-model="setmessage.data.switch_overload" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
					  		<el-button class="btn" @click="send_setmessage('39','switch_overload')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>温度保护</span>
							<el-switch @change='changemessage' active-value='01' inactive-value='00' v-model="setmessage.data.switch_temperature" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
					  		<el-button class="btn" @click="send_setmessage('40','switch_temperature')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>换油提醒</span>
							<el-switch @change='changemessage' active-value='01' inactive-value='00' v-model="setmessage.data.switch_oil" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
					  		<el-button class="btn" @click="send_setmessage('2B','switch_oil')">点击发送</el-button>
						</el-col>
					</el-row>

					<el-row class="line-message">
						<el-col :span='6'>
							<span>开启配对</span>
					  		<el-button class="btn" @click="send_setmessage('0093')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>电压校准</span>
					  		<el-button class="btn" @click="send_setmessage('0027')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>漏电校准</span>
					  		<el-button class="btn" @click="send_setmessage('0004')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>水量清零</span>
					  		<el-button class="btn" @click="send_setmessage('003B')">点击发送</el-button>
						</el-col>
					</el-row>
					<el-row class="line-message">
						<el-col :span='6'>
							<span>参考低压选择</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.select_voltage"></el-input>
					  		<el-button class="btn" @click="send_setmessage('2A','select_voltage')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>温度上限</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.max_temperature"></el-input>
					  		<el-button class="btn" @click="send_setmessage('41','max_temperature')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>首次换油时间</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.first_oil"></el-input>
					  		<el-button class="btn" @click="send_setmessage('2C','first_oil')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>二次换油时间</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.second_oil"></el-input>
					  		<el-button class="btn" @click="send_setmessage('2D','second_oil')">点击发送</el-button>
						</el-col>
					</el-row>
					<el-row class="line-message">
						<el-col :span='6'>
							<span>缺相启动</span>
							<el-switch @change='changemessage' active-value='01' inactive-value='00' v-model="setmessage.data.phase_start" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
					  		<el-button class="btn" @click="send_setmessage('33','phase_start')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>不平衡度</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.imbalances"></el-input>
					  		<el-button class="btn" @click="send_setmessage('34','imbalances')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>漏电参考</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.calibration_maxele"></el-input>
					  		<el-button class="btn" @click="send_setmessage('05','calibration_maxele')">点击发送</el-button>
						</el-col>

						<el-col :span='6'>
							<span>漏电参考最大化</span>
					  		<el-button class="btn" @click="send_setmessage('FF05')">点击发送</el-button>
						</el-col>

					</el-row>
					<el-row class="line-message">
						<el-col :span='6'>
							<span>流量等级</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.flow"></el-input>
					  		<el-button class="btn" @click="send_setmessage('42','flow')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>水压等级</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.hydraulic_pressure"></el-input>
					  		<el-button class="btn" @click="send_setmessage('43','hydraulic_pressure')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>水滤等级</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.water_filtration"></el-input>
					  		<el-button class="btn" @click="send_setmessage('45','water_filtration')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>吸水时间</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.uptake_time"></el-input>
					  		<el-button class="btn" @click="send_setmessage('46','uptake_time')">点击发送</el-button>
						</el-col>
					</el-row>
					<el-row class="line-message">
						<el-col  :span='6'>
							<span>生产日期(年)</span>
							<el-input @change='changemessage' :value="setmessage.data.production_time_year"></el-input>
					  		<el-button class="btn" @click="send_setmessage('10','production_time_year')">点击发送</el-button>
						</el-col>
						<el-col  :span='6'>
							<span>生产日期(月)</span>
							<el-input @change='changemessage' :value="setmessage.data.production_time_month"></el-input>
					  		<el-button class="btn" @click="send_setmessage('11','production_time_month')">点击发送</el-button>
						</el-col>
						<el-col  :span='6'>
							<span>生产日期(日)</span>
							<el-input @change='changemessage' :value="setmessage.data.production_time_date"></el-input>
					  		<el-button class="btn" @click="send_setmessage('12','production_time_date')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>恢复默认开关</span>
					  		<el-button class="btn" @click="send_setmessage('002F')">点击发送</el-button>
						</el-col>
					</el-row>
					<el-row v-if='setmessage.data.message_length>178' class="line-message">
						<el-col class='wid-6' :span='6'>
							<span>频繁启停次数</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.startorend_second"></el-input>
					  		<el-button class="btn" @click="send_setmessage('c9','startorend_second')">点击发送</el-button>
						</el-col>
						<el-col class='wid-6' :span='6'>
							<span>频繁启停时间</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.startorend_times"></el-input>
					  		<el-button class="btn" @click="send_setmessage('ca','startorend_times')">点击发送</el-button>
						</el-col>
						<el-col class='wid-6'  :span='6'>
							<span>漏水保护</span>
							<el-switch @change='changemessage' active-value='00' inactive-value='01' v-model="setmessage.data.switch_weather" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
					  		<el-button class="btn" @click="send_setmessage('C3','switch_weather')">点击发送</el-button>
						</el-col>
						<!--<el-col :span='6'>
							<span>缺水保护(%)</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.water_percent"></el-input>
					  		<el-button class="btn" @click="send_setmessage('cb','water_percent')">点击发送</el-button>
						</el-col>
						<el-col :span='6'>
							<span>缺水保护(s)</span>
						 	<el-input @change='changemessage' v-model="setmessage.data.water_times"></el-input>
					  		<el-button class="btn" @click="send_setmessage('cc','water_times')">点击发送</el-button>
						</el-col>-->
					</el-row>
					<el-row class="line-message">
						<!--<el-col class='wid-6' :span='6'>
							<span>电源版型</span>
							<el-select v-model="setmessage.data.plate_type"  @change='changemessage'>
							    <el-option label="双继" value="00"></el-option>
							    <el-option label="单继/三继"	value="01"></el-option>
						  	</el-select>
					  		<el-button class="btn" @click="send_setmessage('44','plate_type')">点击发送</el-button>
						</el-col>-->


					</el-row>


				</div>
				<div id="join_user_foot">
					<el-row class="line-button">
						<el-col :span="6" >
							<el-button @click='start_equipment'>开机</el-button>
							<el-button @click='getmessage'>获取配置信息</el-button>
						</el-col>
						<el-col :span="6" >
							<el-button @click='close_equipment'>关机</el-button>
							<el-button @click="breakusers">返回用户列表</el-button>
						</el-col>
					</el-row>
				</div>
			</div>
		</el-main>
	</el-container>
</template>

<script>
export default {
	data() {
		return {
			value:'',
			wsServer:'',
			messaged:'',
			showclosemessage:true,
			now_openid:'',//当前连接的用户openid
			connectedList:[],//远程用户列表
			listLoading: false,
			updata_message:'',
			now_type:'',
			message:'',
			usertype:0,
			now_model:'join_user_one',
			menu_join:'1',
			nowReadCurrent:false,
			time_read:'',//读取电流计时器
      sendUserMessage:'',
			setmessage:{
				data:{
					sense_tan: '',
			    	message_length:'',//数据长度
			      	manufacturer:'',//厂商识别代码
			      	edition:'',
			      	chip: '',
			      	electric_less: '',
			      	switch_temperature: '',
			      	max_temperature: '',
			      	phase:'',
		      		rate: '',
		      		roll_code:'',
			      	switch_state:'',
			      	gun_offdelayed:'',
			      	gun_ontime:'',//开枪延时
			      	automatic_shutdown:'',
			      	max_worktime:'',
			      	switch_leakage:'',
			      	switch_overload:'',
			      	switch_oil:'',
			      	gun_num: '',//枪数
			      	select_voltage:'',
			      	calibration_maxele:'',
			      	phase_start:'',
			      	uptake_time:'',
			      	hydraulic_pressure:'',
			      	imbalances:'',
			      	water_filtration:'',
			      	flow:'',
			      	running_time:'',
			      	production_time:'',
			      	plate_type:'',
			      	first_oil: '',
			      	second_oil:'',
			      	no_load_center:'',
			      	full_load_center:'',
			      	reference_electric_leakageADC:'',
			      	reference_electric_leakage:'',
			      	switch_weather:'',//漏水保护
			      	electricity_use:'',
			      	electric_leakage_second:'',//漏电次数
			      	overload_times:'',//过载次数
			      	oil_change:'',//换油
			      	overload_max:'',
				}
			},
			read_current_fn:{
				data:{
			      	electric_now: '',//实时电流
			      	electric_leakage_now: '',//实时漏电
			      	voltage_now: '',//实时电压
			      	electricity_use_second:'',//每秒焦耳
			      	electricity_use_now: '',//用电总量
			      	water_use_now: '',//实时水流
			      	water_use_second: '',//实时流速
			      	full_no:'',//主机运行
			      	lighting_state: '',//灯状态
			      	water_light_one:'',//水枪信号1
			      	water_light_two:'',//水枪信号2
			      	electric_machinery: '',//电机状态
			      	l1_electric:'',//L1
			      	l2_electric:'',
			      	l3_electric:'',
			      	tan:'',
			    }
			},
		}
	},
	methods:{
		changenow_model:function(e){//配置设备页面切换
			var that=this
			that.now_model=e
		},
		changemessage:function(e){//设置发送数据
			var that=this
			console.log(e)
			that.value=e
		},
		changeCheckbox:function(e){
			var that=this
			console.log(e)
			var arry=[]
			var str=''
			if(that.setmessage.data.machine_number==15){
				for(let i=1;i<5;i++){
					var or='0';
					for(let q=0;q<e.length;q++){
						if(e[q].slice(2)==i){
							or='1';
						}
					}
					arry.push(or)
				}
				str='0000'+ arry.reverse().join('')
			}else{
				for(let i=1;i<4;i++){
					var or='0';
					for(let q=0;q<e.length;q++){
						if(e[q].slice(2)==i){
							or='1';
						}
					}
					arry.push(or)
				}
				str='0000'+ arry.reverse().join('')+'0'
			}

			console.log('发送的二进制数据！！！',str)
			str=parseInt(str,2)
			that.setmessage.data.enable_the_motor=str
			that.changemessage(str)
		},
		show_message:function(e,data){//待查
			console.log(data)
			console.log(e,'e')
		},
		handleEdit(index, row) {//发送自定义数据，待改
			var that=this
    		console.log(index, row);
			console.log(that.sendUserMessage)
			var meg={
				type:'motor_protection',
				user_type:'admin',
				message_type:'touser',
				tomessage:{
					tomessage:that.sendUserMessage,
					toopenId:row.openId
				}
			}
			var meg_str=JSON.stringify(meg)
			this.wsServer.send(meg_str)
			setTimeout(()=>{
			  that.getmessage(row.openId)
			},2000)
 		},
 		changemunu:function(e){//待删
 			this.menu_join=e;
 			console.log(this.menu_join)
 		},
 		joinUser(index, row){//接入用户
 			var that=this
 			console.log(index, row);
 			var meg={
				type:'motor_protection',
				user_type:'admin',
				message_type:'touser',
				tomessage:{
					tomessage:'admin_join',
					toopenId:row.openId
				}
			}
 			console.log(row.openId)
 			this.now_openid=row.openId;
 			this.now_type=row.type;
 			this.message=row.message;
			var meg_str=JSON.stringify(meg)
			that.wsServer.send(meg_str)
			that.machine()//渲染数据
			console.log(this)
//			console.log(that.now_model)
 		},
		//返回用户列表发送断开连接
		 breakusers:function(){
		 	var that=this
		 	this.menu_join='1'
		 	this.now_model='join_user_one'
		 	this.stopTimer()
//		 	that.changenow_model('join_user_one')
			if(that.now_openid!=''){
				var meg={
					type:'motor_protection',
					user_type:'admin',
					message_type:'touser',
					tomessage:{
						tomessage:'admin_exit',
						toopenId:that.now_openid
					}
				}
				var meg_str=JSON.stringify(meg)
				that.wsServer.send(meg_str)
			}
//			that.menu_join='当前信息';
			that.updata_message={}
			that.message=''
			that.now_openid=''

		},
		getmessage(openid){//获取配置信息
			console.log(this)
      let openId=openid?openid:this.now_openid
			if(this.now_type=='motor_protection'){
				var meg={
					type:'motor_protection',
					user_type:'admin',
					message_type:'touser',
					tomessage:{
						tomessage:'80000Fc04F',
						toopenId:openId
					}
				}
			}else{
				var meg={
					type:'motor_protection',
					user_type:'admin',
					message_type:'touser',
					tomessage:{
						tomessage:'800005C045',
						toopenId:openId
					}
				}
			}
			var meg_str=JSON.stringify(meg)
			this.wsServer.send(meg_str)
		},
		startTimer(){//读取电流计时器
			var that=this
			that.time_read=setInterval(function(){
				if(that.now_type=='motor_protection'){
					var meg={
						type:'motor_protection',
						user_type:'admin',
						message_type:'touser',
						tomessage:{
							tomessage:'800036C076',
							toopenId:that.now_openid
						}
					}
				}else{
					var meg={
						type:'air_compressor',
						user_type:'admin',
						message_type:'touser',
						tomessage:{
							tomessage:'80000EC04E',
							toopenId:that.now_openid
						}
					}
				}
				var meg_str=JSON.stringify(meg)
				that.wsServer.send(meg_str)
			},2000)
		},
		stopTimer(){
			var that=this
			clearInterval(that.time_read)
			that.time_read=''
			if(!!this.now_openid){
				that.machine()
			}
		},
		//清洗机开关机
		start_equipment(){
			var meg={
				type:'motor_protection',
				user_type:'admin',
				message_type:'touser',
				tomessage:{
					tomessage:'800057C097',
					toopenId:this.now_openid
				}
			}
			var meg_str=JSON.stringify(meg)
			this.wsServer.send(meg_str)
		},
		close_equipment(){
			var meg={
				type:'motor_protection',
				user_type:'admin',
				message_type:'touser',
				tomessage:{
					tomessage:'800058C098',
					toopenId:this.now_openid
				}
			}
			var meg_str=JSON.stringify(meg)
			this.wsServer.send(meg_str)
		},
		send_setmessage(ability_sysno,value){
			var that=this
			var ability=ability_sysno
			var parameter=that.setmessage.data[value]
			console.log(parameter)
			if(!!parameter&&parameter.length==4){
				ability = parameter.toString().slice(2)
				parameter = parseInt(parameter.toString().slice(0,2),16)
			}
			if (ability.length==4){
				parameter = parseInt(ability.slice(0,2),16)
		      	ability = ability.slice(2)
		   }
			if(that.now_type=='motor_protection'){
				switch (ability){
					case '01':
						parameter=parameter*10
					break;
					case '28':
						parameter=parameter*10
					break;
					case '2A':
						parameter=Math.ceil(parameter/2)
					break;
					case '2D':
						parameter=parseInt(parameter/10)
					break;
					case '0E':
						if(that.value=='012f'){
							ability='2f'
							parameter='01'
						}
					break;
				}
			}else{
				switch (ability){
					case '1A':
						parameter=parameter*10
					break;
					case '0B':
						parameter=Math.ceil(parameter/2)
					break;
					case '1D':
						parameter= parameter;
						var two_parameter=that.tostringtwo(Math.abs(parameter));
						console.log(two_parameter)
						if(parameter>0){
							two_parameter='1'+two_parameter.slice(1)
						}
						console.log(two_parameter)
						parameter=parseInt(two_parameter,2)
					break;
				}
			}
			parameter=Number(parameter)
			var verify=parseInt('80', 16)+parameter+parseInt(ability,16)+parseInt('c0', 16);
			verify=verify.toString(16).substr(-2)
			parameter=parameter.toString(16)
			if(parameter.length<2){
				parameter='0'+parameter
			}
			var message_send='80'+parameter+ability+'C0'+verify
			console.log(message_send)
			var meg={
				type:'motor_protection',
				user_type:'admin',
				message_type:'touser',
				tomessage:{
					tomessage:message_send,
					toopenId:that.now_openid
				}
			}
			var meg_str=JSON.stringify(meg)
			that.wsServer.send(meg_str)
		},
		getusers:function (){//获取用户信息
			var meg={
				type:'motor_protection',
				user_type:'admin',
				message_type:'getmessage'
			}
			var meg_str=JSON.stringify(meg)
			this.wsServer.send(meg_str)
		},
		machine:function(){//渲染数据
			var that=this
			switch (that.now_type){
				case 'air_compressor':
				that.setMessage_air_compressor()
				break;
				case 'motor_protection':
				that.setMessage_motor_protection()
				break;
			}
		},
		//设置配置信息-清洗机对象
		setMessage_motor_protection:function (){
			var that=this
			var updata_message=that.message.updata_message
			console.log('渲染配置信息')
      console.log('当前厂商编号',updata_message.slice(74,76))
		    var message_length=parseInt(updata_message.slice(2,4),16)*2//数据长度
		    var gun_plate= parseInt(updata_message.slice(170, 172), 16)//已配枪数和板型
		    gun_plate = gun_plate.toString(2)
		    if (gun_plate.length<8){
		      var num = 8 - gun_plate.length
		      for(var i=0;i<num;i++){
		        gun_plate='0' + gun_plate
		      }
		    }
		    var gun_num
		    if (gun_plate.slice(4, 6)=='00'){
		      gun_num='一机一枪'
		    } else if (gun_plate.slice(4, 6) == '01'){
		      gun_num = '一机双枪'
		    } else {
		      gun_num = '一机三枪'
		    }
		    var plate_type=''
		    var phase,switch_state
		    switch (updata_message.slice(4, 6)){
		      case '0f':
		      phase = '单相';
		        if (gun_plate.slice(6) == '00') {
		          plate_type = '双继'//板型
		        } else if (gun_plate.slice(6) == '01') {
		          plate_type = '单继'
		        }
		      case '1f':
		        phase = 'S800';
		        break;
		      case '2f':
		        phase = '三相';
		        if (gun_plate.slice(6) == '00') {
		          plate_type = '三继'
		        } else if (gun_plate.slice(6) == '01') {
		          plate_type = '单继'
		        }
		        break;
		      case '4f':
		        phase = 'S810';
		      break;
		    }
		    //开关状态
		    if(updata_message.slice(30, 32)=='00'){
		    	switch_state='常闭开关'
		    }else if(updata_message.slice(30, 32)=='01'){
		    	switch_state='常开开关'
		    }else if(updata_message.slice(30, 32)=='02'){
		    	switch_state='无线开关'//无线自动
		    }else if(updata_message.slice(30, 32)=='03'){
		    	switch_state='无线开关'//无线手动
		    }else if(updata_message.slice(30, 32)=='04'){
		    	switch_state='手动开关'
		    }else if(updata_message.slice(30, 32)=='05'){
		    	switch_state='无线开关'//无线搜索
		    }else if(updata_message.slice(30, 32)=='06'){
		    	switch_state='水流开关'
		    }else if(updata_message.slice(30, 32)=='07'){
		    	switch_state='压力开关'
		    }
		    var no_load_center = parseInt(updata_message.slice(64, 66), 16) + parseInt(updata_message.slice(66, 68), 16) * 256//空载
		    var full_load_center = parseInt(updata_message.slice(68, 70), 16) + parseInt(updata_message.slice(70, 72), 16) * 256//满载
		    var reference_electric_leakageADC = parseInt(parseInt(updata_message.slice(22, 24), 16).toString(2)+'00',2).toFixed(2)
		    var reference_electric_leakage = (reference_electric_leakageADC*3.3/1023).toFixed(3)
		    var manufacturer=updata_message.slice(74, 76)
		    var sense_tan = parseInt(updata_message.slice(18, 20), 16) + parseInt(updata_message.slice(20, 22), 16) * 256;
		    that.setmessage.data={
		    	sense_tan: sense_tan,
		    	message_length:message_length,//数据长度
		      	manufacturer:manufacturer,//厂商识别代码
		      	edition:'V'+ updata_message.slice(6, 8)+'-' + updata_message.slice(8, 10),
		      	chip: updata_message.slice(10, 12)==0?'赝品':'正品',
		      	roll_code: parseInt(updata_message.slice(76, 78), 16) + parseInt(updata_message.slice(78, 80) * 100, 16), //滚码号
		      	electric_less: parseInt(updata_message.slice(12, 14),16)/10,
		      	switch_temperature: updata_message.slice(14, 16),
		      	max_temperature: parseInt(updata_message.slice(16, 18), 16),
		      	phase:phase,
	      		rate: updata_message.slice(44, 46) == '00' ? '50Hz' :'60Hz',
	      		switch_state:switch_state,
		      	gun_offdelayed:parseInt(updata_message.slice(26, 28), 16),
		      	gun_ontime:parseInt(updata_message.slice(72, 74), 16)/10, //开枪延时
		      	automatic_shutdown:parseInt(updata_message.slice(28, 30),16),
		      	max_worktime:parseInt(updata_message.slice(60, 62),16),
		      	switch_leakage:updata_message.slice(24, 26),
		      	switch_overload:updata_message.slice(50, 52),
		      	switch_oil:updata_message.slice(126, 128),
		      	gun_num: gun_num,//枪数
		      	select_voltage:parseInt(updata_message.slice(124, 126), 16)*2,
		      	calibration_maxele:parseInt(updata_message.slice(22, 24), 16),
		      	phase_start:updata_message.slice(104, 106),
		      	uptake_time:parseInt(updata_message.slice(174, 176), 16),
		      	hydraulic_pressure:parseInt(updata_message.slice(168, 170),16),
		      	imbalances:parseInt(updata_message.slice(106, 108), 16),
		      	water_filtration:parseInt(updata_message.slice(172, 174), 16),
		      	flow:parseInt(updata_message.slice(166, 168), 16),
		      	running_time:parseInt(updata_message.slice(38, 40), 16)+'小时'+parseInt(updata_message.slice(40, 42), 16)+'分钟'+parseInt(updata_message.slice(42, 44), 16)+'秒',
		      	production_time_year:parseInt(updata_message.slice(32, 34), 16),
      			production_time_month:parseInt(updata_message.slice(34, 36), 16),
      			production_time_date:parseInt(updata_message.slice(36, 38), 16),
		      	plate_type: plate_type,
		      	first_oil: parseInt(updata_message.slice(130, 132), 16),
		      	second_oil: parseInt(updata_message.slice(132, 134), 16)*10,
		      	no_load_center: no_load_center,//空载中压
		      	full_load_center: full_load_center,//满载中压
		      	reference_electric_leakageADC:reference_electric_leakageADC,
		      	reference_electric_leakage: reference_electric_leakage,//漏电参考
		      	switch_weather: updata_message.slice(196, 198),//漏水保护
		      	electricity_use: parseInt(updata_message.slice(96, 98), 16) * 255 + parseInt(updata_message.slice(94, 96), 16),//用电度
		      	electric_leakage_second: parseInt(updata_message.slice(138, 140), 16),//漏电次数
		      	overload_times:parseInt(updata_message.slice(140, 142), 16),//过载次数
		      	oil_change: parseInt(updata_message.slice(128, 130), 16),//换油
		      	overload_max: ((parseInt(updata_message.slice(142, 144), 16) + parseInt(updata_message.slice(144, 146), 16)) * 3.3 / 1023 * sense_tan / 10).toFixed(2),//过载最大值
		    }
		    if(message_length>178){
		    	console.log('数据大于178')
	    		that.setmessage.data.startorend_second=parseInt(updata_message.slice(180, 182), 16)//频繁启停次数
			    that.setmessage.data.startorend_times=parseInt(updata_message.slice(182, 184), 16)//频繁启停时间
			    that.setmessage.data.water_percent=parseInt(updata_message.slice(178, 180), 16)//缺水保护百分比
			    that.setmessage.data.water_times=parseInt(updata_message.slice(176, 178), 16)//缺水保护时间
		    }
		    console.log(that.setmessage.data)
		    that.Read_Currentmotor_fn()
		},
		Read_Currentmotor_fn:function () {
			var that=this
			var read_current=that.message.read_current
			var updata_message=that.message.updata_message
		    var reference_vol;
		    var phase_other = parseInt(read_current.slice(4, 6), 16)
		    if (phase_other==182){
		      reference_vol=410
		    }else{
		      reference_vol = 200
		    }
		//  灯的状态
		    var lighting_state=parseInt(read_current.slice(18, 20),16)
		    lighting_state=this.tostringtwo(lighting_state)
		    var water_light_one=lighting_state.slice(1,2)//水枪
		    var water_light_two=lighting_state.slice(0,1)
		    var electric_low=parseInt(read_current.slice(6, 8),16)//电流低8位
		    var electric_hight= parseInt(read_current.slice(8, 10), 16)//电流高8位
		    var electric_leakage_low= parseInt(read_current.slice(10, 12), 16)//漏电低8位
		    var electric_leakage_hight= parseInt(read_current.slice(12, 14), 16)//漏电高8位
		    var voltage_low= parseInt(read_current.slice(14, 16), 16)//电压低8位
		    var voltage_hight= parseInt(read_current.slice(16, 18), 16)//电压高8位
		    var electric_now = ((electric_leakage_hight * 256 + electric_low) * 3.3 / 1023 * that.setmessage.data.sense_tan/10).toFixed(2)//实时总电流
		    var electric_now_two = ((parseInt(read_current.slice(44, 46), 16) * 256 + parseInt(read_current.slice(42, 44), 16)) * 3.3 / 1023 * that.setmessage.data.sense_tan / 10).toFixed(2)
		    var electric_now_three = ((parseInt(read_current.slice(48, 50), 16) * 256 + parseInt(read_current.slice(46, 48), 16)) * 3.3 / 1023 * that.setmessage.data.sense_tan / 10).toFixed(2)
		    var electric_leakage_now = (((electric_leakage_hight * 256 + electric_leakage_low) * 29 ) / that.setmessage.data.reference_electric_leakageADC).toFixed(2)//实时漏电
		    var voltage_nowADC = voltage_hight * 256 + voltage_low//实时ADC电压
		    var electric_machinery = this.tostringtwo(parseInt(read_current.slice(28, 30), 16))
		    var ele_num = electric_machinery.slice(0, 1)
		    if (electric_machinery.slice(0,1)=='0'){
		      console.log('使用灯判断', electric_machinery)
		      var full_no = lighting_state.slice(2, 3)
		    }else{
		      console.log('使用电机判断', electric_machinery)
		      var full_no = parseInt(electric_machinery.slice(6,7),16)
		    }
		    electric_machinery = parseInt(electric_machinery.slice(7), 16)
		    if (full_no==1){//判断电压，判断电机灯的状态slice(2,3)
		      if (that.setmessage.data.phase=='S810'){
		        var voltage_now = (((voltage_nowADC * reference_vol) / that.setmessage.data.full_load_center + 37.412) / 1.1882).toFixed(2)
		      }else{
		        var voltage_now = ((voltage_nowADC * reference_vol) / that.setmessage.data.full_load_center).toFixed(2)
		      }
		    }else{
		      if (that.setmessage.data.phase == 'S810') {
		        var voltage_now = (((voltage_nowADC * reference_vol) / that.setmessage.data.no_load_center + 37.412) / 1.1882).toFixed(2)
		      }else{
		        var voltage_now = ((voltage_nowADC * reference_vol) / that.setmessage.data.no_load_center).toFixed(2)
		      }
		    }
		    var electricity_use_second = parseInt(read_current.slice(36, 38), 16) * 256 + parseInt(read_current.slice(34, 36), 16)//每秒焦耳
		    var electricity_use_now = electricity_use_second/36000 + that.setmessage.data.electricity_use
		    var water_use_now = (parseInt(read_current.slice(58, 60), 16) * 65536 + parseInt(read_current.slice(56, 58), 16) * 256 + parseInt(read_current.slice(54, 56), 16)) * 20 / that.setmessage.data.flow
		    if ((parseInt(read_current.slice(40, 42), 16) / 60 + parseInt(read_current.slice(38, 40), 16))!=0){
		      var water_use_second = (water_use_now / (parseInt(read_current.slice(40, 42), 16) / 60 + parseInt(read_current.slice(38, 40), 16))) / 1000
		    }else{
		      var water_use_second=0
		    }
		    var tan=parseInt(updata_message.slice(18,20),16)+parseInt(updata_message.slice(20,22),16)*256
		 	var l1_electric=((parseInt(read_current.slice(8, 10), 16) * 256 + parseInt(read_current.slice(6, 8), 16))*3.3/1023*tan/10).toFixed(2)
    		var l2_electric=((parseInt(read_current.slice(44, 46), 16) * 256 + parseInt(read_current.slice(42, 44), 16))*3.3/1023*tan/10).toFixed(2)
    		var l3_electric=((parseInt(read_current.slice(48, 50), 16) * 256 + parseInt(read_current.slice(46, 48), 16))*3.3/1023*tan/10).toFixed(2)
		    water_use_now=(water_use_now/1000000).toFixed(2)
		    water_use_second=water_use_second.toFixed(1)
		    that.read_current_fn.data={
		      	electric_now: electric_now,//实时电流
		      	electric_leakage_now: electric_leakage_now,//实时漏电
		      	voltage_now: voltage_now,//实时电压
		      	electricity_use_second: electricity_use_second.toFixed(2),//每秒焦耳
		      	electricity_use_now: electricity_use_now.toFixed(2),//用电总量
		      	water_use_now: water_use_now,//实时水流
		      	water_use_second: water_use_second,//实时流速
		      	full_no:full_no,//运行状态
		      	lighting_state: lighting_state.slice(2, 3),//电机灯状态
		      	water_light_one:water_light_one,//水枪信号1
		      	water_light_two:water_light_two,//水枪信号2
		      	electric_machinery: electric_machinery,//电机状态
		      	l1_electric:l1_electric,//
		      	l2_electric:l2_electric,
		      	l3_electric:l3_electric,
		      	tan:tan
		    }
		    console.log(that.read_current_fn.data)
		},
		//16位二进制转换
		tostringtwo(num){
		  	var num_two=num.toString(2)
		  	if(num_two.length<8){
		  		var ca=8-num_two.length
		  		for(var i=0;i<ca;i++){
		  			num_two='0'+num_two
		  		}
		  	}
		  	return num_two;
		},
		tryweb:function(){
			var that=this
			that.wsServer = new WebSocket('wss://apw.simcotech.net');
			var wsServer=that.wsServer
			wsServer.onopen = function (e) {
			 	that.getusers();
			 	(typeof e == 'string') && wsServer.send(e);//向后台发送数据
			};
			wsServer.onclose = function (e) {//当链接关闭的时候触发
				if(that.showclosemessage){
					alert('当前连接已断开')
				}
			};
			wsServer.onmessage = function (e) {//后台返回消息的时候触发
			 	if(e.data!='heartbeat'){
			 		//更新用户数据
			 		var message=JSON.parse(e.data)
			 		console.log(message)
			 		that.messaged=message
			   		var html = [];
			   		var user_connected=false;
//			   		that.connectedList=message.data
			   		for(var i=0;i<message.data.length;i++){
						if(that.now_openid!=''&&that.now_openid==message.data[i].openId){
							user_connected=true
							that.updata_message=message.data[i].message.updata_message
							that.read_current=message.data[i].message.read_current
							that.message=message.data[i].message
							console.log(message.data[i])
							console.log(that.updata_message)
							//重新渲染数据
							that.machine()
						}
						console.log(parseInt(message.data[i].message.updata_message.slice(74, 76),16),'当前设备厂商')
						console.log(that.GLOBAL.organDetail.upper_sysno,'操作厂商')
						if(message.data[i].type=='motor_protection'&& (parseInt(message.data[i].message.updata_message.slice(74, 76),16)==that.GLOBAL.organDetail.upper_sysno||that.GLOBAL.organDetail.upper_sysno==that.GLOBAL.admin.upperSysno)){
//							html += "<p  data-openid = "+message.data[i].openId+" data-type="+message.data[i].type+" data-updata_message="+message.data[i].message.updata_message+" data-read_current="+message.data[i].message.read_current+"><span>" + message.data[i].name + "</span>"+'<input class="input" type="text" ><button class="sendmessage">点击发送数据</button><button class="join">接入用户</button>'+"</p>";
							html.push(message.data[i])
						}
			   		}
			   		that.connectedList=html
			   		if(that.now_openid!=''&&user_connected==false){
			   			alert('当前用户已断开连接')
			   		}
			 	}else{
			   		console.log('心跳')
			 	}
			};
			wsServer.onerror = function (e) {//错误情况触发
				console.log(e)
			}
		}
	},
	mounted(){
		this.tryweb()
	},
	beforeDestroy(){
		this.showclosemessage=false;
		this.wsServer.close()
		this.stopTimer()
	},
}
</script>

<style>
	.count_right_sendmessage_down input,.count_right_sendmessage_down button{
		padding: 0;
		height: 21px;
		line-height: 21px;
	}
	.el-switch__label{
		color: #409EFF;
	}
	.el-switch .is-active{
		color: #000;
	}
	.el-checkbox-group{
		flex-direction: column;
	}
	.el-checkbox-group .el-checkbox+.el-checkbox{
		margin-left: 0;
	}
	.el-checkbox.is-bordered+.el-checkbox.is-bordered{
		margin-left: 0;
	}
	#join_user_one{
		padding: 0;
	}
	#join_user_one input{
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		font-size: 12px;
	    height: 21px;
    	line-height: 21px;
    	margin: 0 auto;
	}

	.count_right_sendmessage_down{
		background: #fff;
	}
	.el-col>span{
		    justify-content: center;
		    align-items: center;
		    display: flex;
	}
	.el-col{
		justify-content: center;
    	align-items: center;
	}
	#join_user_foot .el-col{
		justify-content:flex-start
	}
	.menuJoin{
		display: flex;
	    background: #fff;
	}
	.menuJoin .el-button{
		border-radius: 0;
	    border: none;
	}

    	.long_range{
    		background: #409EFF;
    		padding-bottom: 14px;
    	}
    	.count_right_list{
    		width: 85%;
    	}
    	.count_top{
    		height: 50px;
    		line-height: 50px;
    		padding-left: 50px;
    		border-bottom: 1px #fff solid;
    		/*background: #00B7FF;*/
    	}
    	.count_down {
    		display: flex;
    		flex-direction: column;
    	}
    	.count_down p{
    		box-sizing: border-box;
    		padding: 0 50px;
    		border-bottom: 1px solid #fff;
    		width: 100%;
    		display: flex;

    	}
    	.count_down span,.count_down input ,.count_down button{
    		margin: 10px;
    		width: 20%;
    	}

    	.count_top span,.count_top input ,.count_top button{
    		margin: 10px;
    	}
    	.count_right_sendmessage{
    		height: 100%;

    	}
    	.count_right_sendmessage_top{
    		width: 100%;
    	}
    	.count_right_sendmessage_down {
    		/*min-height: 100%;*/
    		display: flex;
    		flex-direction: column;
    	}
    	.count_right_sendmessage_down strong{
    		text-align: center;

    	}
    	.count_right_sendmessage_down div{
    		display: flex;
    		font-size: 12px;
    	}
    	.count_right_sendmessage_down input{
    		text-align: center;
    	}
    	#join_user_two .el-col>.el-input,#join_user_two .el-col>.el-switch{
    		width: 36%;
    		text-align: center;
    		height: 21px;
    		line-height: 21px;
    		justify-content: center;
    		align-content: center;
    	}
    	#join_user_two .el-col>.el-select{
    		width: 42%;
    		text-align: center;
    		height: 21px;
    		line-height: 21px;
    	}
    	#join_user_two .el-col>.el-select i{
    		height: 21px;
    		line-height: 21px;
    	}
    	.count_right_sendmessage_down .el-col>span{
    		width: 56px;
    	}
    	.count_right_sendmessage_down i{
    		font-style: normal;
    		width: 15%;
    		text-align: left;
    	}
    	#join_user_one .line-message div span{
    		width: 40%;
    		margin: auto 0;
    		text-align: center;
    	}
    	.line-message div button{
    		width: 30%;
    		margin: 0 auto;
    	}
    	#join_user_one .line-message div select,#join_user_one .line-message div input{
    		width: 70%;
    		margin: 0 auto;
    	}
    	.count_right_sendmessage_down .line-message>div{
    		border: solid 1px #409EFF;
    		padding: 10px;
    		/*width: 23%;*/
    		margin: 10px 1%;
    		box-sizing: border-box;
    	}
    	.count_right_sendmessage_down .line-message .wid-8{
    		width: 31.33%;
    	}
    	.count_right_sendmessage_down .line-message .wid-6{
    		width: 23%;
    	}
    	.count_right_sendmessage_down .now_state div{
    		border:none;
    		padding:0;
    		/*width:33.33%;*/
    		flex: 1;
    		margin:0;
    		display: flex;
    		flex-direction: row;
    	}
    	.count_right_sendmessage_down .now_state div span{
    		/*width: 60%;*/
    		flex: 1;
    		/*灯状态*/
    		font-size: 12px;
    	}
    	.count_right_sendmessage_down .now_state div i{
    		width: 20px;
    		height: 20px;
    		margin:  auto;
    		border-radius: 50%;
    		box-sizing: border-box;
    	}
    	.count_right_sendmessage_down .now_state .start i{
    		background: #099002;
    		border: 5px solid greenyellow;
    	}
    	.count_right_sendmessage_down .now_state .close i{
    		background: #ccc;
    		border: 5px solid #929394;
    	}
    	.line-button{
    		/*margin: 25px 10px;*/
    		border: 1px solid #fff;
    	}
    	.line-button div{
    		width: 50%;
    	}
    	.line-button button{
    		padding: 10px;
    		margin: 5px 15px;
    	}
    	.line-button div:first-child{
    		display: flex;
    		flex-direction: row-reverse;
    	}
    	.count_left_list li:hover{
    		background: #ccc;
    	}
    	.equipment{

    		background: #ccc;
    	}
    	.count_right_sendmessage_down .log_time input{
    		font-size: 12px;
    		width: 45%;
    	}
    	.count_right_sendmessage_down .log_maxelc>div{
    		padding: 0;
    	}
    	.count_right_sendmessage_down .log_maxelc span{
    		padding-left: 10px;
    		box-sizing: border-box;
    	}
    	.count_right_sendmessage_down .log_maxelc input{
    		margin: 10px auto;
    	}
    	div[data-ability="0A"] select{
    		width: 50%;
    		font-size: 12px;
    	}
    	.count_right_sendmessage_down .line-message div[data-ability="17"]{
    		padding: 0;
    	}
    	.count_right_sendmessage_down .line-message div[data-ability="17"] form{
    		display: flex;
    		padding: 0;
			border: none;
			flex-direction: column;
			margin: 0;
			width: 75px;
    	}

</style>



// WEBPACK FOOTER //
// src/components/long_range_control.vue